export default __webpack_public_path__ + "static/media/new-hero-3.5fc76625.svg";